import { CurrencyCode, Navigation, Product } from '@noths/polaris-dev-ts-types';

// TODO: Don't share types between browse api response and Redux state
import { Category, Filter, Partner, SortOption } from '../../types';

export interface BrowseServiceProductsData {
  currencyCode: CurrencyCode;
  category: Category | null;
  products: Product[];
  filters: Filter[];
  currentPage: number;
  totalPages: number;
  totalProducts: number;
  productsReturnedCount: number;
  queryType: string;
  sortingOptions: SortOption[];
  navigation: Navigation[];
  partner?: Partner;
  errorCode?: string;
  errorMessage?: string;
}

export enum BrowseDataApiPath {
  Category = 'listings/v1/category',
  Search = 'listings/v1/search',
  Partner = 'listings/v1/partner',
  Products = 'listings/v1/products',
}
